import {WidgetDescription} from '../../components/layout/widget/widget-description';
import {DexTransferWidgetImplementation} from './dex-transfer-widget-implementation';
import {DEX_TRANSFER_WIDGET_TYPE_ID} from './dex-transfer-widget-type-id';
import {DexTransferWidgetComponent} from './dex-transfer-widget.component';
import {DexTransferWidgetSettingsService} from './settings/dex-transfer-widget-settings.service';

export const DEX_TRANSFER_WIDGET_DESCRIPTION: WidgetDescription = {
    widgetTypeId: DEX_TRANSFER_WIDGET_TYPE_ID,
    widgetLabel: 'components.widgets.dex-transfer-widget.widget_name',
    widgetImplementationType: DexTransferWidgetImplementation,
    widgetComponentType: DexTransferWidgetComponent,
    widgetSettingsServiceType: DexTransferWidgetSettingsService,
    settingsSchema: [
        {
            name: 'title',
            isShareable: false
        }
    ],
    hasGroupingSupport: false,
    widgetSettingsComponentType: null,
    defaultWidgetSize: [292, 344] // The size in pixels is got by measuring the widget's outer DOM element.
};
